import { ExclamationCircleIcon, ExclamationTriangleIcon, CheckBadgeIcon, ClockIcon } from "@heroicons/react/24/outline"
import Badge from "~/components/ui/Admin/Badge"
import { LONG_TERM_RESERVATION_KINDS, longTermReservationKind } from "~/constants"
import { INVOICE_STATUSES } from "~/decorators/InvoiceDecorator"
import IInvoice from "~/interfaces/IInvoice"
import { isPastDate } from "~/utils/dateUtils"

export const getSendDateTooltipHelperText = (
  sentAt: string,
  sendDate: string,
  invoiceStatus: INVOICE_STATUSES,
): string => {
  if (sentAt) {
    return "This invoice has been sent"
  } else {
    if (isPastDate(sendDate)) {
      return "This invoice was not sent"
    } else {
      if (invoiceStatus == INVOICE_STATUSES.DRAFT) {
        return "Invoice is still a draft, and will not be sent until queued"
      } else {
        if (invoiceStatus == INVOICE_STATUSES.QUEUED) {
          return "This invoice is queued to be sent"
        }
      }
    }
  }
}

export const getSendDateIcon = (sentAt: string, sendDate: string, invoiceStatus: INVOICE_STATUSES) => {
  if (!sentAt && !sendDate) return

  if (sentAt) {
    return <CheckBadgeIcon className="w-5 h-5 text-green-600" />
  } else {
    if (isPastDate(sendDate)) {
      return <ExclamationTriangleIcon className="w-5 h-5 text-red-600" />
    } else {
      if (invoiceStatus == INVOICE_STATUSES.DRAFT) {
        return <ExclamationCircleIcon className="w-5 h-5 text-yellow-600" />
      } else {
        if (invoiceStatus == INVOICE_STATUSES.QUEUED) {
          return <ClockIcon className="w-5 h-5 text-yellow-600" />
        }
      }
    }
  }
}

export const RecurringKindBadgeFor = (kind: longTermReservationKind | "seasonal") => {
  switch (kind) {
    case "seasonal":
      return <Badge color="gray">Seasonal</Badge>
    case LONG_TERM_RESERVATION_KINDS.RENT_AND_UTILITIES:
      return <Badge color="gray">Rent & Utilities</Badge>
    case LONG_TERM_RESERVATION_KINDS.UTILITIES_ONLY:
      return <Badge color="gray">Utilities Only</Badge>
    default:
      return <Badge color="gray">Rent Only</Badge>
  }
}

export const statusBadgeFor = (invoice: IInvoice) => {
  switch (invoice.status) {
    case INVOICE_STATUSES.PAID:
      return <Badge color="green">Paid</Badge>
    case INVOICE_STATUSES.QUEUED:
      return <Badge color="yellow">Queued</Badge>
    case INVOICE_STATUSES.DRAFT:
      return <Badge>Draft</Badge>
    case INVOICE_STATUSES.UPCOMING:
      return <Badge color="blue">Upcoming</Badge>
    case INVOICE_STATUSES.OPEN:
      return <Badge color="blue">Open</Badge>
    default:
      return <Badge color="red">Overdue</Badge>
  }
}
